export const convertToStatusName = (status: string | number) => {
  if (status === 'Approved') {
    return 'Published/Global Library';
  } else if (status === 'New') {
    return 'Draft';
  } else if (status === 'Rejected') {
    return 'Published';
  } else if (status === 'Pending') {
    return 'Published/Submitted';
  } else {
    return status;
  }
};
